<template>
  <div class="edit-user-msg-wrapper" style="background-color: #FFFFFF">
    <div v-if="!isEdit" class="edit-btn" @click="handleOpenEdit">
      <i class="el-icon-edit" /> 编辑
    </div>
    <div v-else class="edit-btn" @click="handleCloseDialog('noValue')">
      返回
    </div>
    <ts-form v-if="isEdit" class="edit-user-msg" :name="updateTenantUser" :form-list="formList" :search-form-data="searchFormData" :is-echo="dataObj.isEcho" @close-dialog="handleCloseDialog" @activationCodes="handleActivationCodes" />
    <ts-exhibition-page v-else :data-list="exhibitionList" />
  </div>
</template>

<script>
import TsForm from '@/components/TsForm/index'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import TsExhibitionPage from '@/components/TsExhibition/index'
import { updateTenantUser, viewUserDetail } from '@/api/manage/userManage'

@Component({
  name: 'EditUserMsg',
  components: {
    TsExhibitionPage,
    TsForm
  }
})
export default class extends Vue {
  @Prop({ default: Object }) dataObj;
  @Prop({ default: Boolean }) isOpen;
  isEdit = false;
  formList = []
  exhibitionList = []; // 展示详情
  searchFormData = {};
  updateTenantUser = updateTenantUser
  @Watch('isEdit')
  handleIsEditChange (newV) {
    if (newV) {
      this.formList = this.dataObj.formList
      console.log(this.dataObj.searchFormData)
      let bool = true
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      for (const key in this.requestData) {
        bool = false
      }
      this.searchFormData = bool ? JSON.parse(JSON.stringify(this.dataObj.searchFormData)) : JSON.parse(JSON.stringify(this.requestData))
      console.log(this.searchFormData)
    }
    this.$emit('on-edit-change', newV)
  }

  @Watch('isOpen')
  handleIsOpenChange (newV) {
    if (newV) {
      this.requestData = {}
      this.exhibitionList = this.handleExhibitionData(this.dataObj.searchFormData)
    }
    this.isEdit = false
  }

  mounted () {
    this.exhibitionList = this.handleExhibitionData(this.dataObj.searchFormData)
  }

  handleActivationCodes (list) {
    console.log(list)
    this.formList[5].options = list
  }

  handleExhibitionData (data) {
    const list = []
    if (data.userRoles.length) {
      data.userRoles.forEach(item => {
        const info = this.dataObj.formList[6].options.find(op => op.id === item)
        if (info) {
          list.push(info.name)
        }
      })
    }
    return [
      {
        label: '基础信息',
        list: [
          {
            key: '用户姓名',
            value: data.name
          },
          {
            key: '用户账号/手机号',
            value: data.mobile
          },
          {
            key: '用户职位',
            value: data.positionName
          },
          {
            key: '用户邮箱',
            value: data.email
          }
        ]
      },
      {
        label: '用户角色',
        list: [
          {
            key: '',
            value: list.length ? list : ''
          }
        ]
      }
    ]
  }

  handleCloseDialog (type, searchData) {
    // this.formList[5].options = []
    this.isEdit = false
    if (type === 'noValue') {
      this.searchFormData = JSON.parse(JSON.stringify(this.dataObj.searchFormData))
    } else {
      // 再调取刷新的方法
      viewUserDetail({ userId: searchData.id }).then(res => {
        if (res.statusCode === 0 && res.success) {
          const roleList = []
          if (res.data.userRoles.length) {
            res.data.userRoles.forEach(item => {
              roleList.push(item.roleId)
            })
          }
          this.requestData = {
            id: res.data.id,
            tenantId: res.data.tenantId,
            name: res.data.name,
            mobile: res.data.mobile,
            activationCodeIds: res.data.activationCodeIds || [],
            positionName: res.data.positionName,
            activationCodeId: res.data.activationCodeId,
            userRoles: roleList,
            email: res.data.email
          }
          this.exhibitionList = this.handleExhibitionData(this.requestData)
          this.searchFormData = JSON.parse(JSON.stringify(this.requestData))
          this.$emit('on-edit-data-change', res.data.name)
        }
      })
    }
  }

  handleOpenEdit () {
    this.isEdit = true
  }
}
</script>

<style lang="scss" >
  .edit-user-msg-wrapper {
    padding: 30px 0 20px 0;
    .edit-user-msg {
      width: 70%;
      margin: auto;
    }
    .edit-btn {
      position: absolute;
      right: 20px;
      top: 20px;
      font-size: 14px;
      cursor: pointer;
      color: #1890ff;
    }
  }

</style>
